import { RfqInterface } from '@app/core/quotes/store/quotes.model';
import { RfqLot } from '@app/core/rfq-lots/store/rfq-lots.model';
import { UnitMeasureInterface } from '@app/modules/unit-measurement/interfaces';

export enum PurchaseOrderLineItemFormField {
  QUANTITY = 'quantity',
  PRICE = 'unit_price',
  DOWNPAYMENT = 'downpayment_amount',
}

export enum CostCalculationMethod {
  WEIGHTED = 'WEIGHTED',
  FIFO = 'FIFO',
  LAST_PO = 'LAST_PO',
}

export interface PickingItem {
  rfqId :number;
  sku :string;
  productName :string;
  orderedQuantity :number;
  availableQuantity :number;
  onhandStockQuantity :number;
  rfq ?:PickingItemRfq;
  location ?:Location;
  warehouse ?:Location;
  lot ?:RfqLot;
  fulfilled ?:boolean;
  incomingOrders ?:PickingItemIncomingOrder[];
}

export interface GetPickingItemsResponse {
  pickingItems :PickingItem[];
  salesOrder :any;
}

export interface PickingItemRfq {
  base_unit_of_measure ?:number;
  id :number;
  total_variant_skus :number;
  internal_sku :string;
  product_name :string;
}

export interface PickingItemIncomingOrder {
  id :number;
  internal_sku :string;
  ordered_qty :number;
  purchase_order_id :number;
  purchase_order :IncomingPurchaseOrder;
}

export interface IncomingPurchaseOrder {
  id :number;
  arrival_due_date :string;
  order_date :string;
}

export interface IPurchaseOrderMultiselectLineItem {
  id :number;
  base_price :number;
  custom_field_values :any;
  default_purchase_unit_id :number;
  default_selling_unit_id :number;
  discount_structure :any;
  is_kit :boolean;
  markup_structure :any;
  oss_limit_notify :number;
  parent_id :number;
  photo :string;
  product_category_id :number;
  product_description :string;
  product_name :string;
  qty_available :number;
  quotations :any;
  retail_price :number;
  sellable :boolean;
  sku :string;
  sub_category_id :number;
  tags :any;
  total_variant_skus :number;
  type :string;
  unit_class_id :number;
  unit_of_measures :UnitMeasureInterface[];
  unit_price :number;
  variant_parent :RfqInterface;
  quantity :number;
  uom_id :number;
}
